import helpers from './helpers';

const initializedHeaders = new WeakSet();
let dropdownDocumentListenersBound = false;

function closeDropdown(item, toggle) {
  item.classList.remove('is-open');
  toggle.setAttribute('aria-expanded', 'false');
}

export default (function () {
  return {
    init() {
      const header = document.querySelector('[data-component="header"]');
      if (!header || initializedHeaders.has(header)) return;

      initializedHeaders.add(header);
      this.initMenuToggle(header);
      this.initDropdowns(header);
    },

    initMenuToggle(header) {
      const toggle = header.querySelector('.js-menu-toggle');
      if (!toggle) return;

      const srOnly = toggle.querySelector('.sr-only');

      const updateMenuToggle = (isOpen) => {
        toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
        toggle.setAttribute('aria-label', isOpen ? 'Close menu' : 'Open menu');

        if (srOnly) {
          srOnly.textContent = isOpen ? 'Close menu' : 'Open menu';
        }
      };

      toggle.addEventListener('click', () => {
        const isOpen = header.classList.toggle('is-menu-open');
        document.body.classList.toggle('is-menu-open', isOpen);
        updateMenuToggle(isOpen);
      });
    },

    initDropdowns(header) {
      const toggles = header.querySelectorAll('.js-dropdown-toggle');
      const isDesktop = () => !helpers.isMobile(header);

      const getItem = (toggle) => helpers.closest(toggle, '.header__nav-item--has-dropdown');

      const closeAllDropdowns = (exceptItem) => {
        helpers.forEach(toggles, (toggle) => {
          const item = getItem(toggle);

          if (!item || item === exceptItem) return;

          closeDropdown(item, toggle);
        });
      };

      const openDropdown = (item, toggle) => {
        if (isDesktop()) {
          closeAllDropdowns(item);
        }

        item.classList.remove('is-closed');
        item.classList.add('is-open');
        toggle.setAttribute('aria-expanded', 'true');
      };

      helpers.forEach(toggles, (toggle) => {
        const item = getItem(toggle);
        const menu = item ? item.querySelector('.header__dropdown') : null;
        const trigger = item ? item.querySelector('.header__nav-dropdown-trigger') : null;

        if (!item || !menu) return;

        const isVisiblyOpen = () => {
          if (item.classList.contains('is-closed')) return false;
          if (item.classList.contains('is-open')) return true;
          return isDesktop() && item.matches(':hover');
        };

        (trigger || toggle).addEventListener('click', (event) => {
          event.stopPropagation();

          if (isVisiblyOpen()) {
            closeDropdown(item, toggle);

            if (isDesktop()) item.classList.add('is-closed');
          } else {
            openDropdown(item, toggle);
          }
        });

        item.addEventListener('mouseleave', () => {
          item.classList.remove('is-closed');
        });

        toggle.addEventListener('keydown', (event) => {
          if (event.key !== 'ArrowDown' || !isDesktop()) return;

          event.preventDefault();
          openDropdown(item, toggle);
          const firstLink = menu.querySelector('.header__dropdown-link');

          if (firstLink) firstLink.focus();
        });

        item.addEventListener('focusout', () => {
          if (!isDesktop()) return;

          requestAnimationFrame(() => {
            if (!item.contains(document.activeElement)) {
              closeDropdown(item, toggle);
            }
          });
        });

        menu.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape') return;

          event.preventDefault();
          closeDropdown(item, toggle);
          toggle.focus();
        });
      });

      if (dropdownDocumentListenersBound) return;

      dropdownDocumentListenersBound = true;

      document.addEventListener('click', (event) => {
        const currentHeader = document.querySelector('[data-component="header"]');

        if (!currentHeader || helpers.isMobile(currentHeader)) return;

        helpers.forEach(currentHeader.querySelectorAll('.header__nav-item--has-dropdown.is-open'), (openItem) => {
          if (openItem.contains(event.target)) return;

          const openToggle = openItem.querySelector('.js-dropdown-toggle');

          if (openToggle) closeDropdown(openItem, openToggle);
        });
      });

      document.addEventListener('keydown', (event) => {
        if (event.key !== 'Escape') return;

        const currentHeader = document.querySelector('[data-component="header"]');

        if (!currentHeader || helpers.isMobile(currentHeader)) return;

        const openItems = currentHeader.querySelectorAll('.header__nav-item--has-dropdown.is-open');

        if (!openItems.length) return;

        helpers.forEach(openItems, (openItem) => {
          const openToggle = openItem.querySelector('.js-dropdown-toggle');

          if (openToggle) closeDropdown(openItem, openToggle);
        });

        const firstToggle = openItems[0].querySelector('.js-dropdown-toggle');

        if (firstToggle) firstToggle.focus();
      });
    },
  };
})();
